import { render } from "./FooterCopyright.vue?vue&type=template&id=d150a11a"
import script from "./FooterCopyright.vue?vue&type=script&lang=js"
export * from "./FooterCopyright.vue?vue&type=script&lang=js"

import "./FooterCopyright.vue?vue&type=style&index=0&id=d150a11a&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__